"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const processSteps = [{
  number: "01",
  title: "Concept & Conviction",
  description: "We strip away the noise to identify high-conviction opportunities where our operational expertise meets a clear market demand."
}, {
  number: "02",
  title: "Rigorous Validation",
  description: "Rapid prototyping and market stress-testing ensure we only commit resources to models that demonstrate undeniable product-market fit."
}, {
  number: "03",
  title: "Scale & Revenue",
  description: "From first hire to institutionalized operations, we deploy our shared services platform to accelerate growth and drive sustainable revenue."
}];
export default function OurProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="130293" id="the-platform" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-6xl">
        {}
        <div className="mb-20 md:mb-32 max-w-3xl">
          <span className="font-default font-semibold uppercase tracking-[0.2em] text-primary block mb-6 text-sm md:text-base">
            The Methodology
          </span>
          <h2 className="font-default font-medium uppercase text-5xl md:text-7xl lg:text-8xl text-foreground leading-[0.9] tracking-tight">
            The Platform <br />
            <span className="text-primary opacity-90">Strategy</span>
          </h2>
        </div>

        {}
        <div ref={ref} className="relative">
          {}
          <div className="absolute left-[2rem] md:left-[4rem] top-8 bottom-8 w-px bg-primary/30 z-0 hidden sm:block" />

          <div className="flex flex-col gap-16 md:gap-24">
            {processSteps.map((step, i) => <div key={step.number} data-index={i} className={`relative z-10 flex flex-col sm:flex-row gap-6 sm:gap-12 md:gap-20 items-start transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 200}ms`
          }}>
                {}
                <div className="w-16 sm:w-[4rem] md:w-[8rem] flex-shrink-0 flex sm:justify-center bg-background py-2 sm:py-4">
                  <span className="font-default font-medium text-6xl md:text-8xl text-primary leading-none tracking-tighter">
                    {step.number}
                  </span>
                </div>

                {}
                <div className="flex-1 sm:pt-4 md:pt-6">
                  <h3 className="font-default font-medium uppercase text-3xl md:text-5xl text-foreground mb-4 md:mb-6 tracking-tight">
                    {step.title}
                  </h3>
                  <p className="font-default text-lg md:text-xl text-foreground/70 leading-relaxed max-w-2xl">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}